import React from 'react';
import { useResponsiveSizes } from '../../../../hooks/use-responsive-sizes';
import type { FormField } from '../../../../types/templates';
import { FieldDisplay } from './pick-display';

interface ConfigFieldProps {
  keyName: string;
  field: FormField | undefined;
  value: unknown;
  getFieldLabel: (key: string) => string;
}

export const ConfigField: React.FC<ConfigFieldProps> = ({ keyName, field, value, getFieldLabel }) => {
  const { fontSize, spacing } = useResponsiveSizes();

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: `${spacing.xs}px ${spacing.sm}px`,
        background: 'rgb(217 217 217 / 18%)',
        borderRadius: 6,
        fontSize: fontSize.base
      }}
    >
      <span style={{ color: '#64748b', flexShrink: 0 }}>{getFieldLabel(keyName)}</span>
      <span style={{ color: '#0f172abb', textAlign: 'right' }}>
        <FieldDisplay field={field} value={value} />
      </span>
    </div>
  );
};
